import React,{Component} from "react";
import ContainerSection from './ContainerSection';
import Scrollable from '../../components/Scrollable';
import Translator from '../../requests/apa/Translator';
import PinStatusWithTimerValidationTask from "../../requests/tasks/user/PinStatusWithTimerValidationTask";
import RequestManager from "../../requests/RequestManager";
import store from "../../store";
import { setDataPinCodes } from "../../actions/pinCodes";
import Utils from 'src/utils/ParentalControl';
import { handleUpdateStatus } from "src/containers/User-Settings/utils.js"
class MultiSection extends Component {

  state={
    status:false,
  }
  statusRequest = new PinStatusWithTimerValidationTask();
  jsonClassification = Utils.getContentClassification()

  toggleStatus=()=>{
    this.setState({status:!this.state.status});
  }

  componentDidMount(){
    this.checkStatus();
  }

  chargeComponent = false

  displayItems(itemsArray , property) {
    for(var i=0; i<itemsArray.length; i++) {
      itemsArray[i].style.display = property;
    }
  }

  displayHeaderButtons() {
    if(document.getElementsByName('switch_contenidos')[0].checked || document.getElementsByName('switch_pagos')[0].checked || document.getElementsByName('switch_canales')[0].checked){
        this.displayItems(document.getElementsByClassName('header-button'), 'block');
    } else {
        this.displayItems(document.getElementsByClassName('header-button'), 'none');
    }
  }




  setClassification(value) {
    const that = this
    this.jsonClassification.map(function(json) {
        if ( json.value === value) {

            console.log('la clasificación es:',json.acronym);
            that.setState({ pin_rating: json.acronym });
            document.getElementsByName('parental_code')[0].value = value;
        }
    });
    this.jsonClassification=this.jsonClassification.map((it)=>{
      if(it.value===value){
        it.active=true;
      }else it.active=false;
      return it;
    });
  }



  async checkStatus() {
    this.chargeComponent = true;
    await handleUpdateStatus(this.statusRequest, this.setState.bind(this), this.displayHeaderButtons.bind(this), this.setClassification.bind(this));

  }

  render() {
    let subsectionName = '';
    if(!this.chargeComponent) return null;
    else{

      if (this.props.subsection) {
        subsectionName = ` / ${this.props.subsection}`
        return (
          <div id="section" className="content-view">
            <div className="header-settings">
              { Translator.get('parental_control_section_one_name', 'Configuración de TV') }<span>{ subsectionName }</span>
            </div>
            <hr/>
            <ContainerSection subsection={ this.props.subsection } />
          </div>
        );
      }
      else
        return (
          <Scrollable height={'450px'}>
            <div id="section" className="content-view" style={{height:'190px'}}>
              <div className="header-settings">
                {Translator.get(this.props.sectionOneName,'Configuración de TV')}
              </div>
              <hr/>
              <ContainerSection section={this.props.sectionOneName} subsection={ this.props.subsection } status={this.state.status} toggleStatus={this.toggleStatus}/>
            </div>
            <div id="section" className="content-view" style={{height:'210px'}}>
              <div className="header-settings">
                {Translator.get(this.props.sectionTwoName, 'Configuraciones de contenidos')}
              </div>
              <hr/>
              <ContainerSection section={ this.props.sectionTwoName} subsection={ this.props.subsection } status={this.state.status} toggleStatus={this.toggleStatus}  />
            </div>
          </Scrollable>
        );
    }
  }
}

export default MultiSection;



// WEBPACK FOOTER //
// ./src/containers/User-Settings/MultiSection.jsx